module.exports = __webpack_public_path__ + "media/images/logos/sony-d1336ed2196a60ced1e4dcc53c61dfd4.png";